const LOGIN_PATH = "/login";

export function isPublicLaunchPath(pathname: string): boolean {
  return ["/", "/login", "/purchase", "/forgot-password", "/reset-password", "/terms-of-use", "/copyright"].includes(pathname)
    || pathname.startsWith("/forms/")
    || /^\/tenant\/[^/]+\/forms\/[^/]+$/.test(pathname);
}

export function isStandaloneDesktopLaunch(): boolean {
  if (typeof window === "undefined") return false;

  const mediaStandalone = window.matchMedia?.("(display-mode: standalone)").matches;
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return Boolean(mediaStandalone || iosStandalone);
}

/**
 * Installed Track Labs apps open at the shared login screen for stale saved
 * routes, but secure password-reset links are an intentional exception: they
 * must render the dedicated in-app new-password page.
 */
export function normalizeStandaloneLaunch(): boolean {
  if (!isStandaloneDesktopLaunch() || typeof window === "undefined") return false;

  const resetLinkIsComplete =
    window.location.pathname === "/reset-password" &&
    Boolean(new URLSearchParams(window.location.search).get("token")) &&
    Boolean(new URLSearchParams(window.location.search).get("tenant"));
  if (resetLinkIsComplete) return false;

  if (isPublicLaunchPath(window.location.pathname)) return false;

  const hasStaleLaunchState =
    window.location.pathname !== LOGIN_PATH ||
    window.location.search.length > 0 ||
    window.location.hash.length > 0;

  if (!hasStaleLaunchState) return false;

  window.history.replaceState(
    { trackLabsDesktopLaunch: true },
    document.title,
    LOGIN_PATH,
  );
  return true;
}
